/**
 * @fileoverview useMarketingLoginAuth — purchase-web's cross-domain
 * marketing-login auth hook. MKT-LOGIN-XDOMAIN-001 (2026-06-29): the reducer +
 * base login/MFA wiring live in the shared `@puffin-core/login-shell`
 * `createMarketingLoginAuth` factory; this module supplies purchase-web's
 * dependency injection only.
 *
 * MKT-LOGIN-XDOMAIN-001/HANDOFF: no `storeAuthData` is injected — the
 * cross-domain login does NOT persist tokens on the marketing origin. The
 * login/verify result is handed to `<MarketingCrossDomainLogin>`, which mints a
 * one-time `/v1/auth/cross-app/handoff` token (PurchasePuffin is a trusted
 * single-user cross-app app) that the tenant origin exchanges into its own
 * `purchase-auth` session. No passkey here: a passkey is bound to the tenant
 * origin's rpId and the marketing apex holds none, so passkey sign-in lives on the
 * tenant login page (login-shell `usePasskeyLogin`); the factory has no passkey
 * option since USER-FACING-GEMS L1b.
 *
 * @module portals/marketing-website/hooks/useMarketingLoginAuth
 */

import { createMarketingLoginAuth } from '@puffin-core/login-shell';
import { marketingLoginAuthService } from '../../../features/auth/services/authService';

export const useMarketingLoginAuth = createMarketingLoginAuth({
  authService: marketingLoginAuthService,
});

export default useMarketingLoginAuth;
